import $ from 'jquery';

import './bootstrap';

import initializeAccordion from './accordion';
import initializeVideoOverlay from './video-overlay';
import initializeLiveStreamCountdown from './livestream-countdown';
import initializeSmoothScroll from './smooth-scroll';
import initializeBackTop from './back-top';
import initializeCountdown from './countdown';
import initializeCollapsibleContent from './collapsible-content';
import initializeAos from './aos';
import initIosDetection from './iosdetection'

$(document).ready(() => {
  initializeAccordion();
  initializeVideoOverlay();
  initializeLiveStreamCountdown();
  initializeSmoothScroll();
  initializeBackTop();
  initializeCountdown();
  initializeCollapsibleContent();
  initializeAos();
  initIosDetection();
});
